import { Either } from 'purify-ts';
import { ApiErrorCatalog, ResolveApiErrorProps } from '../core/api-error';
import { Failure } from '../core/failure';

export interface UploadedMedia {
  mediaId: string;
  mimeType: string;
  fileName: string;
}

export enum MediaRepositoryFailureTypes {
  failToComunicateWithTheServer,
  expired,
}

export class MediaRepositoryFailure extends Failure<MediaRepositoryFailureTypes, void> {
  private constructor(errorMessage: string, errorType: MediaRepositoryFailureTypes) {
    super(errorMessage, errorType, undefined);
  }

  public static fromApiError(props: ResolveApiErrorProps) {
    return new MediaRepositoryFailure(
      ApiErrorCatalog.resolveMessage(props),
      MediaRepositoryFailureTypes.failToComunicateWithTheServer
    );
  }

  public static failToComunicateWithTheServer() {
    return new MediaRepositoryFailure(
      'Falha ao carregar o anexo',
      MediaRepositoryFailureTypes.failToComunicateWithTheServer
    );
  }

  public static expired() {
    return new MediaRepositoryFailure(
      'Este anexo expirou na Meta e não está mais disponível para download.',
      MediaRepositoryFailureTypes.expired
    );
  }
}

export abstract class IMediaRepository {
  public abstract upload(
    companyPhoneNumber: string,
    file: File
  ): Promise<Either<MediaRepositoryFailure, UploadedMedia>>;

  public abstract getMediaObjectUrl(
    companyPhoneNumber: string,
    messageId: string
  ): Promise<Either<MediaRepositoryFailure, string>>;
}
